import { ApolloProvider } from '@apollo/client'
import isPropValid from '@emotion/is-prop-valid'
import type {
  PromptOptions,
  ToastOptions,
} from '@ur-solutions/react-components'
import {
  PromptProvider,
  ToastProvider,
  UrThemeProvider,
} from '@ur-solutions/react-components'
import { UseGlobalProvider } from '@ur-solutions/react-hooks'
import { SearchProvider } from '@/context/SearchContext'
import React from 'react'
import { isMobileOnly } from 'react-device-detect'
import { initialStore } from '@/store'
import Graph from '@/store/graph'
import { StyleSheetManager } from 'styled-components'
import client from '../apollo'
import theme from '../theme'
import { Bootstrap } from './Bootstrap'
import { IntlContextProvider } from './providers/IntlContextProvider'

const toastOptions: ToastOptions = {
  color: 'text.dark',
  background: 'white',
  borderRadius: '12px',
  progressBarColor: '#00c7b1',
}
const promptOptions: PromptOptions = {
  modalProps: {
    placement: 'top-center',
    direction: 'from-top',
    offset: isMobileOnly ? 8 : 36,
  },
}

function shouldForwardProp(propName: string, target: any) {
  if (typeof target === 'string') {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName)
  }
  // For other elements, forward all props
  return true
}

export const Root: React.FC = () => {
  return (
    <StyleSheetManager shouldForwardProp={shouldForwardProp}>
      <ApolloProvider client={client}>
        <IntlContextProvider>
          <UseGlobalProvider store={initialStore}>
            <UrThemeProvider theme={theme}>
              <ToastProvider options={toastOptions}>
                <PromptProvider options={promptOptions}>
                  <SearchProvider>
                    <Graph.Provider>
                      <Bootstrap />
                    </Graph.Provider>
                  </SearchProvider>
                </PromptProvider>
              </ToastProvider>
            </UrThemeProvider>
          </UseGlobalProvider>
        </IntlContextProvider>
      </ApolloProvider>
    </StyleSheetManager>
  )
}

export { promptOptions as rootPromptOptions, toastOptions as rootToastOptions }
